export const DEFAULT_LENGTH_LIST = 10;
export const DEFAULT_STATUSES = ['Черновик', 'Отправлен клиенту'];
export const ERORRS = {
    REQUIRED: 'Это поле обязательно для заполнения',
};
